import { render, staticRenderFns } from "./WallButtons.vue?vue&type=template&id=298c6995&scoped=true&"
import script from "./WallButtons.vue?vue&type=script&lang=js&"
export * from "./WallButtons.vue?vue&type=script&lang=js&"
import style0 from "./WallButtons.vue?vue&type=style&index=0&id=298c6995&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c6995",
  null
  
)

export default component.exports